import { Injectable } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { CookieService } from 'ngx-cookie';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CSRFInterceptor implements HttpInterceptor {
  constructor(private cookies: CookieService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const csrfToken = this.cookies.get(environment.csrfCookieName);
    if (csrfToken) {
      const authReq = req.clone({ setHeaders: { 'X-CSRFToken': csrfToken } });
      return next.handle(authReq);
    }
    return next.handle(req);
  }
}
